import styles from './HeadlineStats.module.css';
import cn from 'classnames';
import { SkeletonizedValue } from '@round/ui-kit';
import { Indicators } from '@round/whitelabel-ui';

export type Stats = {
    label: string;
    value: string | number | null | undefined;
    tooltip?: string;
}[];

type Props = {
    stats: Stats;
    isLoading?: boolean;
    className?: string;
};

const HeadlineStats = ({ stats, isLoading, className }: Props) => {
    return (
        <article className={styles.container}>
            <Indicators.Container className={cn(styles.stats, className)}>
                {stats.map(({ label, value, tooltip }) => (
                    <Indicators.Item key={label} className={styles.item}>
                        <Indicators.Label tooltip={tooltip}>{label}</Indicators.Label>
                        <Indicators.Value>
                            {
                                <SkeletonizedValue isInitialized={!isLoading} width={'4rem'}>
                                    {value ?? '-'}
                                </SkeletonizedValue>
                            }
                        </Indicators.Value>
                    </Indicators.Item>
                ))}
            </Indicators.Container>
        </article>
    );
};

export default HeadlineStats;
